import React from 'react'
import PropTypes from 'prop-types'

import Styles from '../styles/tableview.css'
import GeneralStyles from '../styles/common.css'
import YBLoading from '../components/yb-loading'

class YbPagedTableView extends React.Component {
  constructor () {
    super()
    this.cursors = []
    this.state = {
      loading: false,
      pageIdx: 0
    }
  }

  lastPage () {
    this.setState({ pageIdx: this.state.pageIdx - 1 })
  }

  nextPage () {
    const pageIdx = this.state.pageIdx
    const isLastPage = (pageIdx + 1) * this.props.count === this.props.rows.length;
    if (isLastPage) {
      const newCursor = this.props.rows[this.props.rows.length - 1].id
      this.setState({ loading: true })
      Promise.resolve(this.props.onUpdateCursor && this.props.onUpdateCursor(newCursor))
      .then(_ => this.setState({ pageIdx: pageIdx + 1 }))
      .finally(_ => this.setState({ loading: false }))
    } else {
      this.setState({ pageIdx: pageIdx + 1 })
    }
  }

  render () {
    const { children, title, columns, rows, hasMore, count, smallTitles } = this.props
    const { loading, pageIdx } = this.state
    const start = pageIdx * count
    const end = start + count
    const rowsInPage = rows.slice(start, end)
    const grid = 12 / columns.length

    var pagination = (
      <div className="row mx-auto w-25 my-3" >
        <div className="col">
          <button
            intowowtag="last"
            disabled={loading || pageIdx === 0}
            type="button"
            className={GeneralStyles.button}
            onClick={this.lastPage.bind(this)}>
            <i className="fa fa-chevron-left"/>
          </button>
        </div>
        <div className="col my-auto h-100 text-center">
          {loading ? <YBLoading /> : <span>{pageIdx + 1}</span>}
        </div>
        <div className="col">
          <button
            intowowtag="next"
            disabled={loading || (end >= rows.length && !hasMore)}
            type="button"
            className={GeneralStyles.button}
            onClick={this.nextPage.bind(this)} >
            <i className="fa fa-chevron-right"/>
          </button>
        </div>
      </div>
    );

    if (pageIdx === 0 && end >= rows.length && !hasMore) {
      pagination = <span></span>;
    }

    return (
      <div>
        <div className="row">
          <div className="col-md-8">
            {!smallTitles && (
              <div className={GeneralStyles.pageTitle}>
                {title}
              </div>
            )}
            {smallTitles && (
              <div className={`${GeneralStyles.textAlignLeft}`}>
                <h2>{title}</h2>
              </div>
            )}
          </div>
          <div className={`col-md-4 ${GeneralStyles.textAlignRight}`}>
            {children}
          </div>
        </div>
        <div>
          <div className={Styles.table}>
            <div className={`row ${Styles.tableHeader}`}>
              {columns.map(({ name, key }) => <div key={key} className={`col-md-${grid} ${Styles.tableColumn}`}>{name}</div>)}
            </div>
            {rowsInPage.map(({ id, data }) => (
              <div key={id} className={`row ${Styles.tableRow}`}>
                {columns.map(({ key }) => (
                  <div key={key} className={`col-md-${grid} ${Styles.tableColumn}`}>{data[key]}</div>
                ))}
              </div>
            ))}
          </div>
          {pagination}
        </div>
      </div>
    );
  }
}

YbPagedTableView.propTypes = {
  title: PropTypes.string,
  hasMore: PropTypes.bool,
  count: PropTypes.number.isRequired,
  rows: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired
  })).isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired
  })).isRequired,
  onUpdateCursor: PropTypes.func
};

export default YbPagedTableView
